import React, { useContext } from "react";
import {
  FaUser,
  FaHome,
  FaUsers,
  FaMoneyBillWave,
  FaBell,
  FaChartBar,
  FaSignOutAlt,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import "../styles/sidebarStyle.css";
import profileImg from "../assets/woman (1).png";
import bannerImg from "../assets/vertical-banner.jpg";
import { AuthContext } from "../context/AuthContext";

const Sidebar = ({
  sidebarOpen,
  setSidebarOpen,
  handleLogout,
}) => {
  const { userName, userRole } = useContext(AuthContext);

  return (
    <div className={`sidebar ${sidebarOpen ? "open" : "collapsed"}`}>
      
      {/* HEADER */}
      <div className="sidebar-header">
        {sidebarOpen && (
          <button className="sidebar-main">
            <img
              alt="profile"
              className="profile-image"
              src={profileImg}
            />
            {userName}
          </button>
        )}
      </div>

      {/* VERTICAL BANNER IMAGE */}
      {sidebarOpen && (
        <div className="vertical-banner">
         
        </div>
      )}



      {/* FOOTER */}
      <div className="sidebar-profile"></div>

      {/* LOGOUT */}
      <button className="logout-button" onClick={handleLogout}>
        <FaSignOutAlt className="logout-icon" />
        {sidebarOpen && (
          <span className="logout-text">
            Logout
          </span>
        )}
      </button>
    </div>
  );
};

export default Sidebar;